<ion-button [ngStyle]="{'font-size':size}" [fill]="fillStyle" [color]="value=='on' ? 'main' : value=='custom' ? 'caution' : 'gray3'" (click)="onClick()">
  <ng-content></ng-content>
</ion-button>